import React from "react";
import {
    Player,
    ControlBar,
    BigPlayButton,
    LoadingSpinner,
    PlayToggle,
    VolumeMenuButton,
    FullscreenToggle,
    CurrentTimeDisplay,
    DurationDisplay,
    ProgressControl,
} from "video-react";
import utils from "../app/utils";

import "../../node_modules/video-react/dist/video-react.css";
import "../pages/videos/Queries.css"

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            player: {
                duration: 0,
            }
        };
    }

    componentDidMount() {
        this.player.subscribeToStateChange(this.handleStateChange.bind(this));
    }

    handleStateChange(state) {
        // copy player state to this component's state
        this.setState({
            player: state,
        });
    }

    seekVideo(t) {
        this.player.seek(t);
    }

    getTimelineStyle(s, d) {
        let w = ((s[1] - s[0]) / d) * 100;
        let l = (s[0] / d) * 100;

        return { left: l + "%", width: w + "%" };
    }
    getVideoSrc(i) {
        let url = JSON.parse(localStorage.getItem("user")).user_folder + "/" + i.video.project_folder + "/" + i.video.video_file
        return url;
    }
    formatTimes(t) {
        return "" + utils.formatDuration(t[0]) + "-" + utils.formatDuration(t[1]) + "";
    }

    render() {
        return (
            <div>
                <Player
                    ref={(player) => {
                        this.player = player;
                    }}
                    autoPlay={false}
                    preload="metadata"
                    src={this.getVideoSrc(this.props.result)}
                    startTime={this.props.result.times[0][0]}
                >
                    <LoadingSpinner />
                    <BigPlayButton position="center" />
                    <ControlBar autoHide={false} disableDefaultControls>
                        <PlayToggle key="play-toggle" order={1} />
                        <VolumeMenuButton key="volume-menu-button" order={4} vertical />
                        <CurrentTimeDisplay key="current-time-display" order={5.1} />
                        <DurationDisplay key="duration-display" order={7.3} />
                        <ProgressControl key="progress-control" order={6} />
                        <FullscreenToggle key="fullscreen-toggle" order={8} />
                    </ControlBar>
                </Player>
                <div
                    className="timelineHighlights"
                    hidden={!this.state.player.hasStarted}
                >
                    {this.props.result.times.map((s, i) => (
                        <div
                            key={"highlight" + i}
                            className="timelineHighlight"
                            style={this.getTimelineStyle(s, this.state.player.duration)}
                        />
                    ))}
                </div>
                <div className="resultTitle">{this.props.result.video.project_name} <span>{this.props.result.times.length} results</span></div>
                <div className="resultDesc">
                    {this.props.result.times.map((t, i) => (
                        <span key={"vid-result-time-" + i} onClick={this.seekVideo.bind(this, t[0])}>{this.formatTimes(t)}</span>
                    ))}
                </div>
            </div>
        );
    }
}

export default (Index);
